import React, { useState , useEffect}  from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import DeleteIconButton from "../../components/IconButtons/DeleteIconButton";
import { useStateContext } from '../../contexts/ContextProvider';
import { useMaquinasMutations, useCapacidadesMutations } from '../../hooks'
import { ButtonSubmit, FooterPages } from '..';
import DataTable from 'react-data-table-component';
import {getCapacidadesTipo} from "../../services/Capacidades";
import toast from 'react-hot-toast';


const initialState = {
empresa:'',
codigo: '',
nombreMaquina: '',
tarifaEstudio: '',
capacidad: '',
estado: 'Activo',
};

const NuevaMaquina = ({vecinoData, onChangeVecino}) => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const [sucursalesData, setSucursalesData] = useState([]);
  const [idCapacidad, setIdCapacidad] = useState('');
  const { addMaquina, updateMaquinaC } = useMaquinasMutations();
  const {removeCapacidad} = useCapacidadesMutations();
  const { addCapacidad, updateCapacidadC } = useCapacidadesMutations();

  useEffect(() => {
    const fetchData = async (codigo) => {
      const cSel = await getCapacidadesTipo(codigo);
      setSucursalesData(cSel);
    };
    if(vecinoData) {
      setFormData(vecinoData);
      fetchData(vecinoData.codigo);
    }
  }, [vecinoData]);

  const handleChange = (e) =>{
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAgregaCapacidad = async (e) => {
    e.preventDefault(); // Evita que el formulario se envíe

  if (formData.capacidad === '') return;

  try {

    // console.log('idCapacidad ' + idCapacidad);
    if (idCapacidad !== '') {

      const newCapacidadUp = {_id: idCapacidad, codigo: formData.codigo , capacidad: formData.capacidad };

    //  console.log('actualizar capacidad ' + JSON.stringify(newCapacidadUp));
      // Actualizar capacidad existente
      await updateCapacidadC.mutateAsync( newCapacidadUp );

      setSucursalesData((prevCapacidades) =>
        prevCapacidades.map((item) =>
          item._id === idCapacidad ? { ...item, capacidad: formData.capacidad.toString() } : item
        )
      );

    } else {
     
      const newCapacidad = { codigo: formData.codigo , capacidad: formData.capacidad };
      
      // console.log('crear capacidad ' + JSON.stringify(newCapacidad));

      // Simular la creación en el servidor y obtener el nuevo id
      const createdCapacidad = await addCapacidad.mutateAsync( newCapacidad );
      
      setSucursalesData((prevCapacidades) => [...prevCapacidades, createdCapacidad]);
    }

    // Limpiar el formulario
    setIdCapacidad('');
    setFormData({ ...formData, capacidad: '' });


  } catch (error) {
    toast.error('Error al agregar la capacidad');
    console.log(' OCURRIO EL ERROR '  + error);
  }



  };

  const handleSubmit = async (e) =>{
    e.preventDefault();

    // Validaciones

    if(!vecinoData._id) 
    {
      // console.log('crear VECINO');
       await addMaquina.mutateAsync( formData );
    } else
    { 
       await updateMaquinaC.mutateAsync( formData );
    };
    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevamaquina );

  }
  
  const handleCompletaMaquina = async (row) =>{
    setIdCapacidad(row._id);
    setFormData({ ...formData, capacidad: row.capacidad.toString()});  
  };

  const handleEliminar = async (row) => {
    //console.log('voy a eliminar ' + row._id);
    setSucursalesData((prevData) => prevData.filter((item) => item._id !== row._id));
    await removeCapacidad.mutateAsync(row._id);
    setSucursalesData((prevData) =>(prevData));
  };

 /* const handleChangeCapacidad = (capacidad) => {
    setCapacidad(capacidad);
  };*/

  const customStyles = {
    table: {
      style: {
        backgroundColor: 'white',
      },
    },
    headRow: {
      style: {
        backgroundColor: 'white',
        fontSize: 12,
        borderRadius: 8,
        fontWeight: '400',
        color: '#AEB2D7',
        borderWidth: 0,
        textAlign: 'center',
        headerStyles:{
          backgroundColor: '#F2F5FE',
          fontWeight: 'bold',
          color: '#2F336A',
        },
      },
    },
    rows: {
      style: {
        minHeight: '50px',
        margin: '4px 0px',
        backgroundColor: 'white',
        borderRadius: 8,
        fontSize: 10,
        rowStyles:{
          borderBottom: 1,
        }
      },
    },
  };

  const columns = [
    {
      name: '',
      width: '40px',
      cell: (row) => ( <DeleteIconButton onClick={() => handleEliminar(row)} /> )
    },
    {
      name: 'Capacidad',
      width: '120px',
      selector: row => row.capacidad.toString(),
      sortable: true
    }
  ];


  return (
    <form  onSubmit={handleSubmit} >
     <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
     <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-1/2 p-8">
          <div className="flex justify-between items-center">
              <p className="font-semibold text-lg">{!vecinoData ? "Nuevo": "Editar" } Maquinas</p>
              <button
                  type="button"
                  onClick={ () => { setIsClicked( !isClicked.nuevamaquina )} }
                  style={{ color: 'rgb(153, 171, 180)', borderRadius: '50%' }}
                  className="text-2xl p-3 hover:drop-shadow-xl hover:bg-light-gray"
                >
                <MdOutlineCancel />
              </button>
          </div>

          <div className="mt-5 space-y-4">
              <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4" >
                  <div className="flex flex-col">
                    <label className="text-sm font-semibold mb-1">Código*</label>
                    <input
                        className="text-xs border border-gray-300 p-2 rounded"
                        type="text"
                        placeholder=""
                        name="codigo"
                        value= {formData.codigo}
                        required
                        onChange={handleChange}
                      />
                  </div>
                  <div className="col-span-2">
                    <div className="flex flex-col">
                      <label className="text-sm font-semibold mb-1">Descripción</label>
                      <input
                          className="text-xs border border-gray-300 p-2 rounded"
                          type="text"
                          placeholder=""
                          name="nombreMaquina"
                          value= {formData.nombreMaquina}
                          onChange={handleChange}
                        />
                    </div>
                  </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4" >
                  <div className="flex flex-col">
                    <label className="text-sm font-semibold mb-1">Tarifa Estudio*</label>
                    <input
                        className="text-xs border border-gray-300 p-2 rounded"
                        type="number"
                        placeholder=""
                        name="tarifaEstudio"
                        value= {formData.tarifaEstudio}
                        required
                        onChange={handleChange}
                      />
                  </div>  
                  <div className="flex flex-col">
                        <label className="text-sm font-semibold mb-1">Estado*</label>
                        <select className="text-xs border border-gray-300 p-2 rounded" name="estado" value= {formData.estado} required onChange={handleChange}>
                          <option value="ACTIVO">Activo</option>
                          <option value="INACTIVO">Inactivo</option>
                          <option value="ELIMINADO">Eliminado</option>
                        </select>
                    </div>
                </div>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-2 gap-4" >
                <div className="flex flex-col">
                  <label className="text-sm font-semibold mb-1">Capacidad</label>
                  <input
                      className="text-xs border border-gray-300 p-2 rounded"
                      type="text"
                      placeholder=""
                      name="capacidad"
                      value= {formData.capacidad}
                      onChange={handleChange}
                    />
                </div>
                <div className="flex flex-col">
                  <button
                    onClick={handleAgregaCapacidad}
                    className="bg-blue-600 text-white py-2 px-4 rounded mt-4"
                  >
                    Agregar
                  </button>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
                <div className="flex flex-col">
                  <DataTable
                    columns={columns}
                    data={sucursalesData}
                    highlightOnHover
                    pagination={true}
                    striped
                    className="border border-gray-300 rounded-lg shadow-sm"
                    noHeader={true}
                    selectableRowsHighlight
                    customStyles={customStyles}
                    onRowClicked={(row) => handleCompletaMaquina(row)}
                    noDataComponent={'No hay Capacidades creadas'}
                  />
                </div>  
              </div>    

              <div className="bg-white p-6 rounded-lg shadow-lg items-end">
                  <button
                      onClick={handleSubmit}
                      className="bg-blue-600 text-white py-2 px-4 rounded mt-4"
                  >
                    { !vecinoData ? "Crear Nuevo": "Guardar Cambios"}
                  </button>
              </div>           
              <FooterPages />  
          </div>

        </div>
      </div>
    </form>
  );
};

export default NuevaMaquina;